import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/reset.css";
import "./assets/login-style.css";

import setupAxiosInterceptors from "./axiosInterceptor";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Load appropriate manifest
const pathParts = window.location.pathname.split("/");

let manifestHref = "/manifest.json"; // default manifest

if (pathParts[1] === "play" && pathParts[2]) {
  const screenId = pathParts[2];
  const baseURL = process.env.REACT_APP_BASE_URL;
  manifestHref = `${baseURL}/api/manifest.json?screen=${screenId}`;
}

const manifestLink = document.createElement("link");
manifestLink.rel = "manifest";
manifestLink.href = manifestHref;
document.head.appendChild(manifestLink);

// Setup Axios Interceptors
setupAxiosInterceptors();

// Render App
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Register service worker for PWA support
serviceWorkerRegistration.register();

// Report web vitals
reportWebVitals();
